import { InitPage } from "../../index";
import swal from "sweetalert";

declare var $;
declare var App: any;
declare const enableSalesOrderCartonBarcodeScanVerification: string;
declare const totalPickedQty;
declare const totalVerifiedQty;
declare const resetVerifiedQtyAndCreateLogPath: string;
declare const searchBarcodePath: string;
declare const canIFinishThisProcess: string;
declare const confirmPinCodeUsersPath: string;
declare const currentUserEmail: string;
declare const failedSoundUrl: string;
declare const alreadyScannedSoundUrl: string;
declare const succeededSoundUrl: string;
declare const tenantCode: string;

class MfVerifyShipping {
    failedAlertSound: any;
    succeededAlertSound: any;
    alreadyScannedSound: any; // Shouldn't be any we need to use the right data type
    barcodeInputElement = document.getElementById("barcode_input");

    init() {
        if (typeof enableSalesOrderCartonBarcodeScanVerification != "undefined" &&
            enableSalesOrderCartonBarcodeScanVerification === "false") {
            console.log('The carton barcode scan verification feature is false');
            return;
        }
        const totalOfExpected           = document.getElementById("total_of_expected");
        const totalOfVerified           = document.getElementById("total_of_verified");
        const backToMenu                = $("#back_to_menu");
        const backToPickUpStep          = $("#back_to_pickup_step");
        const completedVerifiedShipping = $(".verified_shipping");

        totalOfExpected.textContent = totalPickedQty.toString();
        totalOfVerified.textContent = totalVerifiedQty.toString();

        backToMenu.on("click", (e) => {
            // when user doesn't start to verify the process, we don't need to \
            // show warning, reset verified qty and create a log
            if (totalOfVerified.textContent.toString() == '0') { return; }
            e.preventDefault();
            this.playFailedSound();
            this.confirmBackOperation(e);
        });

        backToPickUpStep.on("click", (e) => {
            if (totalOfVerified.textContent.toString() == '0') { return; }
            e.preventDefault();
            this.playFailedSound();
            this.confirmBackOperation(e);
        });

        // prevent to submit form with enter in barcode input
        $("#barcode_input").bind('keypress keydown keyup', function(e){
            if(e.keyCode == 13) { e.preventDefault(); }
        });

        $("input:text[id=barcode_input]").on("keyup", (e) => {
            if(e.keyCode==13) {
                if ($(e.target).val() == "") {
                    this.playFailedSound();
                    this.showSweetAlert('Attention', 'warning', 'Barcode box is empty, please enter your barcode');
                    return;
                }
                const soProcessId = this.getUrlParameters("id",'',true);
                $.ajax({
                    url: searchBarcodePath,
                    type: "POST",
                    data: { search_text: e.target.value, id: soProcessId, totalPickedQty, totalVerifiedQty },
                    success: (responseJSON) => {
                        if (responseJSON.error == false) {
                            if (responseJSON.messageType == 'success') {
                                this.playSucceededSound();
                                this.showAndHideElement('.picked_success_icon', 1000);
                                this.increaseTotalOfVerifiedQty('total_of_verified');
                                this.increaseTotalOfVerifiedQty(responseJSON.id);
                                this.increaseTotalOfVerifiedQty('sum_of_verified_qty');
                            } else {
                                this.playAlreadyScannedSound();
                                this.showSweetAlert('Attention', responseJSON.messageType, responseJSON.message);
                            }
                        }
                    },
                    error: ({responseJSON}) => {
                        if (responseJSON.error == true) {
                            this.playFailedSound();
                            this.showSweetAlert('Stop', responseJSON.messageType, responseJSON.message);
                            // $(e.target).focus();
                        }
                    }
                });
                $(e.target).val('');
            }
        });

        completedVerifiedShipping.on("click", (e) => {
            e.preventDefault();
            const valueOfTotalVerified = parseInt(this.getValueOfElement('#total_of_verified'), 10);
            const valueOfTotalExpected = parseInt(this.getValueOfElement('#total_of_expected'),10);

            /*if (canIFinishThisProcess == 'false'){
                this.showSweetAlert('Stop', 'error', 'You dont have the role of the warehouse manager');
                this.playFailedSound();
                return;
            }*/

            if (valueOfTotalVerified > valueOfTotalExpected) {
                // with new logic its impossible and incorrect if user see this warning
                this.playFailedSound();
                this.showSweetAlert('Attention', 'error', `You can not pick more than ${valueOfTotalExpected}`);
                return;
            }

            if (valueOfTotalVerified < valueOfTotalExpected) {
                // show warning and get pin and auth for override and complete this step
                swal({
                    title: 'Warning!',
                    text: 'You can not continue because you have not barcode scanned each item on the SO to confirm you have picked the expected quantities. ' +
                            'Please, close this screen to barcode scan all boxes, and the retry, Or to skip this verification click the "Continue & Override" button ' +
                                'to enter the bypass manager PIN#.',
                    icon: "warning",
                    closeOnClickOutside: false,
                    buttons: {
                        cancel: {
                            text: "Close",
                            value: false,
                            visible: true,
                            className: "sn-btn-silver",
                            closeModal: true
                        },
                        confirm: {
                            text: "Continue & Override",
                            value: true,
                            visible: true,
                            className: "sn-btn-red",
                            closeModal: true
                        }
                    },
                    dangerMode: true,
                }).then((response) => {
                    if (response) {
                        this.confirmPinAndComplete(e);
                    } else {
                        return false;
                    }
                });
                return;
            }

            if (valueOfTotalVerified == valueOfTotalExpected) {
                // without Pin, log, check auth and role go to the next level
                const formAssignInspection = $("#assign_inspection_form");
                formAssignInspection.submit();
            }
        });
    }

    // Usage of this method:
    //  1. update sum of Verified Qty in table ( sum value in last row of table )
    //  2. update related row Verified QTY column
    //  3. update total of Verified in top of page
    increaseTotalOfVerifiedQty(IdName) {
        const elementOfVerifiedQty = document.getElementById(IdName);
        const contentOfVerifiedQty = elementOfVerifiedQty.textContent;
        if (contentOfVerifiedQty != '—') {
            const currentVerifiedQty = parseInt(contentOfVerifiedQty, 10);
            elementOfVerifiedQty.textContent = String(currentVerifiedQty + 1);
        } else if (contentOfVerifiedQty == '—') {
            elementOfVerifiedQty.textContent = String(1);
        }
    }

    getValueOfElement(el_name) {
        return document.querySelector(el_name).textContent;
    }

    showSweetAlert(title, type, message) {
        swal({
            title: title,
            text: message,
            icon: type,
            className: 'swal-blue-color-for-ok'
        }).then((response) => {
            if (response) { this.barcodeInputElement.focus(); }
        });
    }

    showAndHideElement(element, duration_ms) {
        $(element).show();
        setTimeout(() => {
            $(element).hide();
            this.barcodeInputElement.focus();
        }, duration_ms);

    }

    confirmBackOperation(element) {
        swal({
            title: 'Are you sure?',
            text:  'The barcode verification data will be lost. Are you sure you want to send this ticket back?',
            icon: "error",
            closeOnClickOutside: false,
            buttons: {
                cancel: {
                    text: "No",
                    value: false,
                    visible: true,
                    className: "sn-btn sn-btn-sm sn-btn-silver",
                    closeModal: true
                },
                confirm: {
                    text: "Yes",
                    value: true,
                    visible: true,
                    className: "sn-btn sn-btn-sm sn-btn-red",
                    closeModal: true
                }
            },
            dangerMode: true,
        }).then((response) => {
            if (response) {
                const soProcessId = this.getUrlParameters("id",'',true);
                $.ajax({
                    url: resetVerifiedQtyAndCreateLogPath,
                    data: { id: soProcessId },
                    method: "POST",
                }).done(function (data) {
                    window.location.href = element.target.href;
                }).fail(function (data) {
                    location.reload();
                });
            } else {
                this.barcodeInputElement.focus();
                return false;
            }
        });
    }

    confirmPinAndComplete(element) {
        swal('Enter PIN number to continue :', {
            content: {
                element: "input",
                attributes: {
                    placeholder: "Enter the #Pin",
                    type: "password"
                },
            },
            closeOnClickOutside: true,
            className: 'swal-blue-color-for-ok'
        } as any).then((value) => {
            if (value && value != '' && typeof value != null) {
                const soProcessId = this.getUrlParameters("id",'',true);
                $.ajax({
                    url: confirmPinCodeUsersPath,
                    data: { pin_code: value, email: currentUserEmail, tenant_code: tenantCode, id: soProcessId, module: 'so_zone' },
                    method: "POST",
                }).done(function (data) {
                    if (data.status == true) {
                        const formAssignInspection = $("#assign_inspection_form");
                        formAssignInspection.submit();
                    } else {
                        let errorMessage = 'Your PIN number is incorrect';
                        if (data.status == false && data.message) { errorMessage = data.message }
                        swal({ title: 'Error!',
                                        text: errorMessage,
                                        icon: "error",
                                        className: 'swal-blue-color-for-ok' });
                    }
                }).fail(function (data) {
                    swal({ title: 'Failed!',
                        text: 'This operation failed, please try again',
                        icon: "error",
                        className: 'swal-blue-color-for-ok' });
                });
            } else {
                swal.close();
            }
        });
    }

    getUrlParameters(parameter, staticURL, decode){
        let currLocation = (staticURL.length) ? staticURL : window.location.search,
            parArr = currLocation.split("?")[1].split("&"), returnBool = true;

        for(let i = 0; i < parArr.length; i++){
            const parr = parArr[i].split("=");
            if(parr[0] == parameter){
                return (decode) ? decodeURIComponent(parr[1]) : parr[1];
                returnBool = true;
            }else{
                returnBool = false;
            }
        }

        if(!returnBool) return false;
    }

    playFailedSound() {
        if(failedSoundUrl) this.failedAlertSound = new Audio(failedSoundUrl);
        if(this.failedAlertSound) this.failedAlertSound.play();
    }

    playSucceededSound() {
        if(succeededSoundUrl) this.succeededAlertSound = new Audio(succeededSoundUrl);
        if(this.succeededAlertSound) this.succeededAlertSound.play();
    }

    playAlreadyScannedSound() {
        if(alreadyScannedSoundUrl) this.alreadyScannedSound = new Audio(alreadyScannedSoundUrl);
        if(this.alreadyScannedSound) this.alreadyScannedSound.play();
    }
}


export function LoadPage() {
    InitPage("so_to_zone_processes pending_inspection", () => {
      if (!window.location.href.includes("pending_inspection")) {
          return;
      }

      const verifyShipping  = new MfVerifyShipping();
      verifyShipping.init();
    });
}
